import {
  faBasketShopping,
  faCircleNotch,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Layout from "../../../components/layout";
// import PageHeader from "../../../components/pageHeader";
import { RootState } from "../../../redux/store";
import { API_BASE_URL } from "../../../utils/useFetch";
import ProfileNav from "../components/profileNav";
import OrderCard from "./components/orderCard";

interface IOrder {
  id: number;
  no: number;
  created_at: string;
  payMethod: string;
  deliverType: string;
  address: string | null;
  cost: number;
  meals: {}[];
}
const Orders = () => {
  const [orders, setOrders] = useState<IOrder[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const userData = useSelector((store: RootState) => store.user.userInfo);

  const fetchOrders = useCallback(async () => {
    const _formData = new FormData();
    _formData.append("mobile", userData.mobile);
    _formData.append("code", userData.code);
    const response = await fetch(API_BASE_URL + "v2/get_orders", {
      method: "POST",
      body: _formData,
    });
    return response.json();
  }, [userData]);

  useEffect(() => {
    setIsLoading(true);
    fetchOrders().then((response) => {
      setIsLoading(false);
      setOrders(response);
    });
  }, [fetchOrders]);

  return (
    <Layout>
      {/* <PageHeader /> */}
      <section className='container mx-auto flex '>
        <div className='flex-1 border lg:ml-8 bg-white'>
          <div className='border-b border-solid'>
            <ProfileNav activeRoute={"/profile/orders"} />
          </div>
          <div className='p-4'>
            {isLoading && (
              <div className='text-center p-4'>
                <div className='text-4xl text-gray-300'>
                  <FontAwesomeIcon
                    icon={faCircleNotch}
                    className='rotate-animation'
                  />
                </div>
              </div>
            )}

            {!isLoading && orders.length === 0 && (
              <div className='text-center p-4'>
                <div className='text-8xl text-gray-300'>
                  <FontAwesomeIcon icon={faBasketShopping} />
                </div>
                <div>سفارشی ندارید</div>
              </div>
            )}
            {!isLoading &&
              orders.length > 0 &&
              orders.map((order) => (
                <OrderCard
                  key={order.id}
                  order={order}
                />
              ))}
          </div>
        </div>
      </section>
    </Layout>
  );
};
export default Orders;
